import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Collapse,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';

import User from '../../../components/User';

import {
  createUser,
  resetUserCRUD,
  resetUserError,
} from '../../../store/actions/user-actions';
import { authSetError } from '../../../store/actions/auth-actions';

import registerStyles from './registerStyles';
import config from '../../../config';

import Cookies from 'js-cookie';

const Register = (props) => {
  const styles = registerStyles();
  const dispatch = useDispatch();
  const search = useLocation().search;

  const [referralCode, setReferralCode] = useState(null);

  // Selectors
  const loadingUser = useSelector((state) => state.user.loading);
  const errorUser = useSelector((state) => state.user.error);
  const errorMessageUser = useSelector((state) => state.user.errorMessage);
  const userCreated = useSelector((state) => state.user.userCreated);

  const [isMobileAuth] = useState(Cookies.get('mobileAuth'));

  // Effects
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(resetUserCRUD());
  }, [dispatch]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const authProcessor = searchParams.get('authprocessor');

    if (authProcessor && authProcessor === 'cancelled') {
      dispatch(authSetError('Sign-in cancelled.'));
    } else if (authProcessor && authProcessor === 'rejected') {
      dispatch(authSetError('Sign-in failed.'));
    }
  }, [dispatch, search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const referralCodeParam = searchParams.get('referralcode');

    if (referralCodeParam) {
      setReferralCode(referralCodeParam);
    }
  }, [search]);

  // Handlers
  const handleSubmit = (registerUserPayload) => {
    if (referralCode) {
      registerUserPayload = {
        ...registerUserPayload,
        referralCode,
      };
    }

    dispatch(createUser(registerUserPayload));
  };

  const handleMobileCancel = () => {
    window.location.href = '/login?authprocessor=cancelled'
  }

  const handleLoginNow = () => {
    props.history.push('/login');
  };

  return (
    <div className={styles.root}>
      <StyledEngineProvider injectFirst>
        <Card className={styles.registerCard}>
          <Box>
            <CardHeader
              title={
                userCreated
                  ? 'Account registration successful!'
                  : 'Create account'
              }
              subheader={
                userCreated
                  ? 'Thank you for filling out your information! We’ve sent you an email to set your personalize password.'
                  : 'Please make sure to enter correct details'
              }
            />
            <CardContent>
              <Collapse in={!userCreated}>
                <Collapse in={errorUser}>
                  <Box mb={1}>
                    <Alert
                      severity="error"
                      onClose={() => {
                        dispatch(resetUserError());
                      }}
                    >
                      {errorMessageUser}
                    </Alert>
                  </Box>
                </Collapse>
                <User
                  model={{}}
                  onSubmit={handleSubmit}
                  submitButtonText="Create Account"
                  hideState={
                    config.REACT_APP_SENDER_STATE_VISIBILITY === 'HIDE'
                  }
                  withPassword={
                    config.REACT_APP_REGISTER_WITH_PASSWORD === 'true'
                  }
                  withRecaptcha={config.REACT_APP_RECAPTCHA_ENABLED === 'true'}
                  isBankIdEnabled={!!config.REACT_APP_AUTH_PROCESSOR_URL}
                />
              </Collapse>
              <Collapse in={userCreated}>
                <Box mb={2}>
                  <Alert severity="success">You're now registered!</Alert>
                </Box>
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  type="button"
                  disabled={!userCreated}
                  onClick={handleLoginNow}
                >
                  Login now
                </Button>
              </Collapse>
            </CardContent>
            <Box mx={2} mb={2}>
              <Typography>
                By registering your account, you agree to our{' '}
                <a href="/about/termsandconditions" rel="noopener noreferrer">
                  Terms and Conditions
                </a>{' '}
                and{' '}
                <a href="/about/privacypolicy" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                .
              </Typography>
            </Box>
            <Divider />
            <Box px={1} pt={1} pb={2}>
              <CardActions>
                {isMobileAuth ?
                  <>
                    <div className={styles.grow} />
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleMobileCancel}
                    >
                      Cancel
                    </Button>
                  </>
                  :
                  <>
                    <Grid container direction="column">
                      <Typography>Already registered?</Typography>
                      <Typography color="secondary">
                        {config.REACT_APP_ASK_REGISTER_SUB_CATCHPHRASE}
                      </Typography>
                    </Grid>
                    <div className={styles.grow} />
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleLoginNow}
                    >
                      Login
                    </Button>
                  </>
                }

              </CardActions>
            </Box>
            <Backdrop
              className={styles.backdrop}
              style={{ position: 'absolute' }}
              open={loadingUser}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </Card>
      </StyledEngineProvider>
    </div>
  );
};

export default Register;
